import React from 'react';
import { Navigate, Route, Routes, useLocation, useNavigate, useParams } from 'react-router-dom';
import { Card, Layout, Menu } from 'antd';

import { PageHeader } from 'components/page';
import { usePermissions } from 'hooks';
import Forbidden from 'pages/public/AccessDenied';
import { PageLoading } from 'pages/public/Loading';
import NotFoundPage from 'pages/public/NotFoundPage';

import Airmiles from './airmiles/index';
import CashCredit from './cashCredit';
import CreditCards from './creditCard/index';
import Hotels from './hotels/index';
import MemFeeWaiver from './memFeeWaiver';
import Vouchers from './vouchers';

const CreditCardRedemptionSettings = () => {
  const params = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  const { actions, loading } = usePermissions('points_redemptions');

  const options = [
    { path: 'credit-cards', label: 'Credit Cards', component: CreditCards },
    { path: 'airmiles', label: 'Airmiles', component: Airmiles },
    { path: 'hotels', label: 'Hotels', component: Hotels },
    { path: 'vouchers', label: 'Vouchers', component: Vouchers },
    { path: 'cash-credit', label: 'Cash Credit', component: CashCredit },
    { path: 'mem-fee-waiver', label: 'Mem. Fee Waiver', component: MemFeeWaiver }
  ];

  const findKeyIndex = (pathname: string): string => {
    const index = options.findIndex(o => {
      const route = `/p/credit_card_redemption_settings/${o.path}`;
      return pathname.indexOf(route) !== -1;
    });
    return index.toString();
  };

  if (loading) return <PageLoading />;
  if (!actions?.includes('configure') && !loading) return <Forbidden />;

  return (
    <>
      <PageHeader title="Credit Card Redemption Settings" />
      <Card>
        <Layout>
          <Layout.Sider
            //@ts-ignore
            theme="white"
            width={185}
          >
            <Menu
              mode="inline"
              selectedKeys={[findKeyIndex(location.pathname)]}
              style={{ height: '100%', textAlign: 'right' }}
            >
              {options.map((o, index) => {
                const route = `/p/credit_card_redemption_settings/${o.path}`;
                return (
                  <Menu.Item key={index} onClick={() => navigate(route)}>
                    {o.label}
                  </Menu.Item>
                );
              })}
            </Menu>
          </Layout.Sider>
          <Layout>
            <Layout.Content style={{ padding: 16, background: 'white' }}>
              <Routes>
                <Route index element={<Navigate to="credit-cards" replace />} />
                {options.map(o => (
                  <Route path={`${o.path}/*`} element={<o.component />} key={o.path} />
                ))}
                <Route path="*" element={<NotFoundPage />} />
              </Routes>
            </Layout.Content>
          </Layout>
        </Layout>
      </Card>
    </>
  );
};

export default CreditCardRedemptionSettings;
